import React from "react";

export default function CommentPanel() {

  return (

    <div className="card mb-4">

      <div className="card-body">

        Comments

      </div>

    </div>

  );

}